import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { getServerNow } from "@/lib/useTimeSync";
import i18n from "@/plugins/i18n"

export function useCountdownTimer(targetDateRef, { onExpire } = {}) {
    const remainingMs = ref(0);
    const isOver = ref(false);

    let intervalId = null;

    const update = () => {
        const targetRaw = targetDateRef.value;
        const target = new Date(targetRaw).getTime();

        const now = getServerNow();
        const distance = target - now;

        if (distance <= 0) {
            remainingMs.value = 0;
            isOver.value = true;

            clearInterval(intervalId);

            if (typeof onExpire === 'function') {
                onExpire();
            }
        } else {
            remainingMs.value = distance;
        }
    };

    const formattedCountdown = computed(() => {
        const ms = remainingMs.value;

        const days = Math.floor(ms / (1000 * 60 * 60 * 24));
        const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((ms % (1000 * 60)) / 1000);

        const pad = (n) => String(n).padStart(2, '0');

        const dayText = i18n.global.t((days % 10 > 4 || days % 10 === 0 || (days > 10 && days < 20))
            ? 'дней'
            : (days % 10 === 1 ? 'день' : 'дня'));

        return (days > 0 ? `${days} ${dayText} ` : '') + `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    });

    onMounted(() => {
        update();
        intervalId = setInterval(update, 1000);
    });

    onUnmounted(() => {
        clearInterval(intervalId);
    });

    watch(targetDateRef, () => {
        isOver.value = false;
        update();
    });

    return {
        formattedCountdown,
        remainingMs,
        isOver,
    };
}
